"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9070],{

/***/ 9070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useValidatedField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97544);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48080);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);









var Heading2 = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(__webpack_require__.e(/* import() */ 7477).then(__webpack_require__.t.bind(__webpack_require__, 77477, 23)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77477)
            ];
        }
    }
});
var Row = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(__webpack_require__.e(/* import() */ 9323).then(__webpack_require__.bind(__webpack_require__, 69323)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69323)
            ];
        }
    }
});
var Link = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(__webpack_require__.e(/* import() */ 7638).then(__webpack_require__.bind(__webpack_require__, 97638)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97638)
            ];
        }
    }
});
var Text = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(__webpack_require__.e(/* import() */ 5468).then(__webpack_require__.bind(__webpack_require__, 45468)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45468)
            ];
        }
    }
});
var PrimaryButton = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(__webpack_require__.e(/* import() */ 842).then(__webpack_require__.bind(__webpack_require__, 10842)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10842)
            ];
        }
    }
});
var AlphanumericInput = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(__webpack_require__.e(/* import() */ 3008).then(__webpack_require__.bind(__webpack_require__, 93008)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93008)
            ];
        }
    }
});
var setAmplitudeUserId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(email) {
        var ref, ref1, ref2;
        return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    window === null || window === void 0 ? void 0 : (ref = window.amplitude) === null || ref === void 0 ? void 0 : ref.setUserId(email);
                    _ctx.next = 5;
                    return (ref2 = window === null || window === void 0 ? void 0 : (ref1 = window.amplitude) === null || ref1 === void 0 ? void 0 : ref1.flush()) === null || ref2 === void 0 ? void 0 : ref2.promise;
                case 5:
                    _ctx.next = 10;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_4__/* .error */ .vU)("Failed to set Amplitude device id ".concat(String(_ctx.t0)));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function setAmplitudeUserId(email) {
        return _ref.apply(this, arguments);
    };
}();
var LoginWithExistingAccount = function(param) {
    var onSuccess = param.onSuccess, successMessage = param.successMessage, headingMessage = param.headingMessage, secondMessage = param.secondMessage;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), submitAttempted = ref[0], setSubmitAttempted = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), submitFailed = ref1[0], setSubmitFailed = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSubmitInProgress = ref2[0], setIsSubmitInProgress = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loginSucceeded = ref3[0], setLoginSucceeded = ref3[1];
    var required = function(value) {
        if (!submitAttempted) {
            return "";
        }
        return "".concat(value || "").trim() ? "" : "Required";
    };
    // eslint-disable-next-line no-control-regex
    var emailPattern = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
    var validEmail = function(email) {
        if (!submitAttempted) {
            return "";
        }
        if (!emailPattern.test(email)) {
            return "Please enter a valid Email";
        }
        return "";
    };
    var showFeedBack = function() {
        return submitAttempted;
    };
    var password = (0,_hooks_useValidatedField__WEBPACK_IMPORTED_MODULE_3__/* .useValidatedField */ .Q)("", required, showFeedBack);
    var email = (0,_hooks_useValidatedField__WEBPACK_IMPORTED_MODULE_3__/* .useValidatedField */ .Q)("", validEmail, showFeedBack);
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1, Account, migrateFromLegacy, KustomerLogIn, user, success, results;
            return _tmp_codebuild_output_src312_src_s3_01_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isSubmitInProgress) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setSubmitAttempted(true);
                        setSubmitFailed(false);
                        _ctx.prev = 4;
                        _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
                        _ctx.next = 8;
                        return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                            return [
                                __webpack_require__.e(/* import() */ 2285).then(__webpack_require__.bind(__webpack_require__, 12285)),
                                __webpack_require__.e(/* import() */ 9542).then(__webpack_require__.bind(__webpack_require__, 9542)), 
                            ];
                        });
                    case 8:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1, 2);
                        ref1 = ref[0];
                        Account = ref1.default;
                        migrateFromLegacy = ref1.migrateFromLegacy;
                        KustomerLogIn = ref[1].KustomerLogIn;
                        if (!(!email.issues && !password.issues)) {
                            _ctx.next = 34;
                            break;
                        }
                        setIsSubmitInProgress(true);
                        user = {
                            email: "".concat((email === null || email === void 0 ? void 0 : email.value) || "").trim(),
                            password: password === null || password === void 0 ? void 0 : password.value
                        };
                        _ctx.next = 19;
                        return migrateFromLegacy({
                            identifier: email === null || email === void 0 ? void 0 : email.value,
                            password: password === null || password === void 0 ? void 0 : password.value
                        });
                    case 19:
                        _ctx.next = 21;
                        return Account.signUserIn(user);
                    case 21:
                        success = _ctx.sent.success;
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_4__/* .log */ .cM)("Account.signUserIn success: ".concat(String(success)));
                        if (!success) {
                            _ctx.next = 33;
                            break;
                        }
                        // eslint-disable-next-line no-restricted-globals
                        setLoginSucceeded(true);
                        _ctx.next = 27;
                        return Promise.allSettled([
                            KustomerLogIn(),
                            setAmplitudeUserId(user.email), 
                        ]);
                    case 27:
                        results = _ctx.sent;
                        results.forEach(function(result) {
                            if (result.status === "rejected") {
                                (0,_services_Log__WEBPACK_IMPORTED_MODULE_4__/* .error */ .vU)("result", result);
                            }
                        });
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_4__/* .log */ .cM)("components/Login/LoginWithExistingAccount.tsx calling onSuccess()");
                        onSuccess("reload");
                        _ctx.next = 34;
                        break;
                    case 33:
                        {
                            setSubmitFailed(true);
                        }
                    case 34:
                        _ctx.next = 40;
                        break;
                    case 36:
                        _ctx.prev = 36;
                        _ctx.t2 = _ctx["catch"](4);
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_4__/* .error */ .vU)("Login Failed ".concat(String(_ctx.t2)));
                        setSubmitFailed(true);
                    case 40:
                        _ctx.prev = 40;
                        setIsSubmitInProgress(false);
                        return _ctx.finish(40);
                    case 43:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    36,
                    40,
                    43
                ]
            ]);
        }));
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var withFormChange = function(param) {
        var setValue = param.setValue;
        return function(e) {
            setSubmitAttempted(false);
            setValue(e.target.value);
        };
    };
    var emailErrorMessage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (email.issues) {
            return email.issues;
        }
        return submitFailed && submitAttempted ? "Invalid email and / or password" : undefined;
    }, [
        email.issues,
        submitAttempted,
        submitFailed
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
        cols: 1,
        gapY: "lg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Heading2, {
                textTag: "p",
                children: headingMessage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                className: "h-10",
                children: secondMessage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("form", {
                name: "user login form",
                autoComplete: "on",
                action: "",
                noValidate: true,
                onSubmit: function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                    cols: 1,
                    gap: "md",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AlphanumericInput, {
                            id: "login_email",
                            name: "email",
                            type: "email",
                            placeholder: "Email",
                            autoComplete: "email",
                            label: "Email",
                            inputRef: email.ref,
                            value: email.value,
                            onChange: withFormChange(email),
                            errorMessage: emailErrorMessage,
                            "data-testid": "login_email"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AlphanumericInput, {
                            id: "login_password",
                            autoComplete: "current-password",
                            name: "password",
                            type: "password",
                            placeholder: "Password",
                            label: "Password",
                            inputRef: password.ref,
                            value: password.value,
                            onChange: withFormChange(password),
                            errorMessage: password.issues ? password.issues : undefined,
                            "data-testid": "login_password"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Link, {
                            className: "no-underline",
                            href: "/forgot-password",
                            target: "_blank",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                size: "sm",
                                className: "cursor-pointer",
                                "data-testid": "forgot_password_link",
                                children: "Forgot your password?"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PrimaryButton, {
                            htmlType: "button",
                            "data-testid": "Login_Submit_CTA",
                            id: "Submit_Login_Button",
                            onClick: onSubmit,
                            className: "relative",
                            children: isSubmitInProgress ? "... Signing In" : "Sign in"
                        }),
                        loginSucceeded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                            children: successMessage
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LoginWithExistingAccount);


/***/ }),

/***/ 97544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useValidatedField; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// valid -> !errors
// invalid, but not showing errors YET -> feedback=false, !!errors
// invalid, AND showing errors -> feedback=true, !!errors
var never = function() {
    return "";
};
var always = function() {
    return true;
};
function useValidatedField(initial) {
    var errors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : never, showFeedback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : always;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), value = ref[0], setValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(errors(value)), issues = ref1[0], setIssues = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(showFeedback(value) ? issues : ""), showIssues = ref2[0], setShowIssues = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setValue(initial);
    }, [
        initial,
        setValue
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var checkErrors = function checkErrors() {
            var newErrorValues = errors(value);
            if (isMounted.current) {
                setIssues(newErrorValues);
            }
        };
        checkErrors();
    }, [
        value,
        setIssues,
        errors
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setShowIssues(showFeedback(value) ? issues : "");
    }, [
        value,
        setShowIssues,
        showFeedback,
        issues
    ]);
    var setter = function(newValue) {
        if (isMounted.current) {
            setValue(newValue);
        }
    };
    return {
        value: value,
        setValue: setter,
        issues: issues,
        showIssues: showIssues,
        ref: ref3
    };
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useValidatedField)));


/***/ })

}]);